// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"726f3686","159":"74c5c797","502":"4b3dd679","671":"716c49c0","867":"6fafd989"}[chunkId] + ".chunk.js";
};